import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const schema = z.object({
  senderName: z.string(),
  defaultReplyTo: z.string().optional(),
});

export type AuthedEmailEditFormContextType = z.infer<typeof schema>;

type AuthedEmailEditFormProviderProps = {
  defaultValues: AuthedEmailEditFormContextType;
  children: React.ReactNode;
};

export const AuthedEmailEditFormProvider = ({
  children,
  defaultValues,
}: AuthedEmailEditFormProviderProps) => {
  const methods = useForm<AuthedEmailEditFormContextType>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    defaultValues,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
